import { getServerHost } from 'utils/getServerHost'

export const VERSION_PREFIX = '/api/v1'

export const getExtensionRequestUrl = (teamUrlName: string) =>
  `https://${getServerHost()}${VERSION_PREFIX}/teams/${teamUrlName}/free-trial/extension-request`
